import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ExpoFormLayer from "../components/ExpoFormLayer";

const ExpoFormPage = () => {
    return (
        <MasterLayout>
            <ExpoFormLayer />
        </MasterLayout>
    );
};

export default ExpoFormPage;
